// extracted by mini-css-extract-plugin
export default {"control":"Control_control__Ca4bz","button":"Control_button__uyIOg"};